<template>
  <div class="pt-20">
    <base-header />
    <router-view class="flex-grow" />
    <base-footer :class="{ 'pb-14': hasStickyFooter }" />
    <shortlist-modal />
    <search-modal />
    <book-detail-modal />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/base/Header.vue";
import Footer from "@/components/base/Footer.vue";
import ShortlistModal from "@/components/modals/ShortlistModal.vue";
import SearchModal from "@/components/modals/SearchModal.vue";
import BookDetailModal from "@/components/modals/BookDetail.vue";

export default {
  components: {
    "base-header": Header,
    "base-footer": Footer,
    "shortlist-modal": ShortlistModal,
    "search-modal": SearchModal,
    "book-detail-modal": BookDetailModal,
  },
  computed: {
    hasStickyFooter() {
      return this.$route.meta.stickyFooter;
    },
  },
};
</script>
